import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {useSelector} from "react-redux";
import {SwitchUser} from "../../../helpers/helpers";
import Modal from "../../common/Modal/Modal";

const ConfirmInternetExplorerPopup = () => {
  const {t} = useTranslation();
  const [confirmedUsageOfInternetExplorer, setConfirmedUsageOfInternetExplorer] = useState(false)

  // const isIE = !!document.documentMode;
  const isIE = () => {
    const ua = window.navigator.userAgent;
    return ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1;
  };
  const user = useSelector((state) => state.auth);

  // returns actual profile or the impersenation profile field from the user object
  const userProfile = SwitchUser(user);
  // get the user role of type UserRoleEnum
  const role = userProfile?.role;


  const userListForShowingPopUp = ["PRIVATE", "COMPANY", "CONDOMINIUM_ADMIN", "MUNICIPAL_USER", "PARTNER"]


  return (isIE() && !confirmedUsageOfInternetExplorer && (!role || userListForShowingPopUp.includes(role))) && (
    <div className="" data-testid={"ConfirmInternetExplorerPopup"}>
      <Modal
        show={true}
        description={t("internet-explorer.confirm-popup")}
        type={"button"}
        onFirstClick={() => { setConfirmedUsageOfInternetExplorer(true)} }
        linkTitle={t("email.moda.btnConfirm")}
      />
    </div>
  )
}

export default ConfirmInternetExplorerPopup
